import axios from 'axios';
import dayjs from 'dayjs';
import { getStatisticParams, iniOSQQ } from './pureUtil';

let attaObj = {};
let reportUrl = '';

/**
 *初始化ATTA
 * @param url
 * */
function initReportUrl(url) {
  reportUrl = url;
}

/**
 *初始化Beacon
 * @param {object} obj, 初始化上报参数
 * */
function setReportPublicParams(obj) {
  attaObj = obj;
}

function setReportEventRefer(data) {}

/**
 * 新增初始化参数
 * @param {object} obj, 初始化上报参数
 * */
const addReportPublicParams = (obj) => {
  attaObj = {
    ...attaObj,
    ...obj,
  };
};

/**
 * @param {string} key, 事件key
 * @param {object} obj, 额外上报数据
 * @param {string} [url]
 * */
const report = (key, obj?: Record<string, any>, url?: string) => {
  if (!key) return;
  if (!url && !reportUrl) return false;
  const reportTime = dayjs().format('YYYY-MM-DD HH:mm:ss');
  const { extraStatisticParams, ...restObj } = obj || {};
  let mergedStatisticParams: string;
  try {
    const baseStatisticParams = JSON.parse(getStatisticParams());
    mergedStatisticParams = extraStatisticParams
      ? JSON.stringify({ ...baseStatisticParams, ...extraStatisticParams })
      : JSON.stringify(baseStatisticParams);
  } catch {
    mergedStatisticParams = JSON.stringify(extraStatisticParams || {});
  }
  const data: Record<string, any> = {
    ...attaObj,
    ...restObj,
    statisticParams: mergedStatisticParams,
    eventTime: reportTime,
    uploadTime: reportTime,
  };
  const [page, pageModule, actType] = key.split('_');
  data.eventCode = key;
  data.page = page;
  data.pageModule = obj?.pageModule || pageModule;
  data.actType = obj?.actType || actType;
  // ios 在QQ环境内navigator.sendBeacon发送请求时丢失body数据，导致上报异常
  if (!iniOSQQ() && navigator.sendBeacon) {
    navigator.sendBeacon(url || reportUrl, JSON.stringify(data));
    attaObj = {
      ...attaObj,
      eventRefer: data.eventCode,
    };
    return;
  }
  axios.request({
    url: url || reportUrl,
    method: 'POST',
    data,
  });
  attaObj = {
    ...attaObj,
    eventRefer: data.eventCode,
  };
  return;
};

export { report, addReportPublicParams, initReportUrl, setReportPublicParams, setReportEventRefer };
